import { Box, Container, Typography, Grid, Stack } from "@mui/material";
import React, { useState } from "react";
import ProductCard from "../../components/cards/ProductCard";
import GlobalButton from "../../components/button";
import ProductData from "../../json/Products.json";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { t } from "i18next";

const Products = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [limit, setLimit] = useState(0);
  const { isLoading, data } = useSelector((state) => state.productReducer);
  

  return (
    <Box component={"section"} bgcolor={"text.raisinBlack"} py={4}>
      <Typography
        variant="heading_pr"
        component={"h1"}
        color={"text.white"}
        textAlign={"center"}
        textTransform={"capitalize"}
      >
        {t("homeExporeHead")}
      </Typography>
      <Container maxWidth={"lg"} sx={{ mt: 4 }}>
        <Grid container spacing={2}>
          {data?.map((item, index) => (
            <Grid key={index}  item xs={6} sm={4} md={2.4}>
              <ProductCard cardData={item} />
            </Grid>
          ))}
        </Grid>

        <Stack my={5} alignItems={"center"}>
          <GlobalButton
            btnText={"checkAllProducts"}
            handleClickBtn={() => navigate("/")}
            styleProps={{
              height: 50,
              width: "auto",
              backgroundColor: "text.white",
              color: "text.black",
              borderRadius: 1.5,
              fontSize: "1rem",
              fontWeight: 600,
            }}
          />
        </Stack>
      </Container>
    </Box>
  );
};

export default Products;
